import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotVideos from "./components/HotVideos";
import Categories from "./components/Categories";
import LiveRoom from "./components/LiveRoom";
import Topics from "./components/Topics";
import HowItWorks from "./components/HowItWorks";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

const faqJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "吃瓜视频网是干什么的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "吃瓜视频网是一个主打围观现场与弹幕互动的娱乐热点视频平台，汇聚综艺名场面、影视吐槽、社会热点等内容。你可以边看视频边发弹幕、参与评论热议和话题讨论，和全网吃瓜群众一起边看边聊。",
        },
      },
      {
        "@type": "Question",
        "name": "需要注册登录才能看视频和发弹幕吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "看视频、围观热门现场无需注册即可直接观看。发弹幕和参与话题评论目前也保持低门槛，注册后可以同步自己的点赞、收藏和讨论记录。",
        },
      },
      {
        "@type": "Question",
        "name": "弹幕互动是怎么玩的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "在弹幕现场播放视频时，输入框里打一句话点发送，就会以彩色弹幕的形式从屏幕上飘过。系统会自动安排弹幕的轨道和速度。",
        },
      },
      {
        "@type": "Question",
        "name": "话题广场里的热度是怎么来的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "话题热度综合了围观人数、弹幕量、评论数与分享次数，实时计算并更新。参与人数越多的讨论，排名越靠前。",
        },
      },
      {
        "@type": "Question",
        "name": "会不会有审核和内容规范？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "站内实行内容与评论审核，禁止人身攻击、造谣和不良信息。我们鼓励理性吃瓜、文明吐槽。",
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <HotVideos />
        <Categories />
        <LiveRoom />
        <Topics />
        <HowItWorks />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}